import React, { useState, useEffect } from "react";
import "./ModalEdicion.css";
import { updateConsulta, updateHistoriaClinica } from "../../../../services/historiaClinica";

const ModalEditarConsulta = ({ historiaClinica, onClose, onSave }) => {
  const [consultas, setConsultas] = useState([]);
  const [datosConsulta, setDatosConsulta] = useState({});

  useEffect(() => {
    if (historiaClinica && historiaClinica.fechaConsulta) {
      const consultaInicial = {
        fechaConsulta: historiaClinica.fechaConsulta,
        indicacionesAdicionales: historiaClinica.indicacionesAdicionales || "",
        notasModificacion: historiaClinica.notasModificacion || {},
      };

      const consultasSeguimiento = historiaClinica.consultas || [];

      const todasLasConsultas = [consultaInicial, ...consultasSeguimiento].sort(
        (a, b) => new Date(b.fechaConsulta) - new Date(a.fechaConsulta)
      );

      setConsultas(todasLasConsultas);

      const datosIniciales = {};
      todasLasConsultas.forEach((consulta) => {
        datosIniciales[consulta.fechaConsulta] = {
          indicacionesAdicionales: consulta.indicacionesAdicionales || "",
          notasModificacion: consulta.notasModificacion || {},
        };
      });
      setDatosConsulta(datosIniciales);
    }
  }, [historiaClinica]);

  const handleChange = (e, fecha) => {
    const { value } = e.target;

    setDatosConsulta((prev) => {
      const cambios = { ...prev };

      if (!cambios[fecha]) {
        cambios[fecha] = {
          indicacionesAdicionales: "",
          notasModificacion: {},
        };
      }

      const fechaModificacion = new Date().toLocaleString();

      const valorInicial =
        prev[fecha]?.notasModificacion?.indicacionesAdicionales?.primerValor ||
        prev[fecha]?.indicacionesAdicionales ||
        "";

      cambios[fecha] = {
        indicacionesAdicionales: value,
        notasModificacion: {
          indicacionesAdicionales: {
            primerValor: valorInicial,
            ultimaModificacion: {
              valor: value,
              fecha: fechaModificacion,
              medico: "Médico Actual",
            },
          },
        },
      };

      return cambios;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const primeraConsulta = consultas.find((c) => c.fechaConsulta === historiaClinica.fechaConsulta);
      const consultasRestantes = consultas.filter((c) => c.fechaConsulta !== historiaClinica.fechaConsulta);

      if (primeraConsulta) {
        await updateHistoriaClinica(historiaClinica.id, {
            indicaciones_adicionales: datosConsulta[primeraConsulta.fechaConsulta].indicacionesAdicionales,
            notas_modificacion: datosConsulta[primeraConsulta.fechaConsulta].notasModificacion,
           });
      }

      for (const consulta of consultasRestantes) {
        await updateConsulta(consulta.id, {
          indicaciones_adicionales: datosConsulta[consulta.fechaConsulta]?.indicacionesAdicionales || "",
          notas_modificacion: datosConsulta[consulta.fechaConsulta]?.notasModificacion || {},
        });
      }

      onSave();
      onClose();
    } catch (error) {
      console.error("❌ Error en handleSubmit:", error);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Editar Consulta</h3>
        <form onSubmit={handleSubmit}>
          <div className="info-alert">
            ⚠️ Por Normas Oficiales, no se pueden modificar los datos de una consulta una vez registrada.
            Solo puedes agregar notas en "Indicaciones Adicionales".
          </div>
          {consultas.length === 0 ? (
            <p className="info-alert">No hay consultas registradas aún.</p>
          ) : (
            consultas.map((consulta) => (
              <div key={consulta.fechaConsulta}>
                <label>Consulta del {new Date(consulta.fechaConsulta).toLocaleString()}</label>
                <label>Indicaciones Adicionales:</label>
                <textarea
                  name="indicacionesAdicionales"
                  value={datosConsulta[consulta.fechaConsulta]?.indicacionesAdicionales || ""}
                  onChange={(e) => handleChange(e, consulta.fechaConsulta)}
                ></textarea>

                {datosConsulta[consulta.fechaConsulta]?.notasModificacion?.indicacionesAdicionales && (
                  <p className="nota">
                    Valor inicial: '{datosConsulta[consulta.fechaConsulta].notasModificacion.indicacionesAdicionales.primerValor}' |
                    Última modificación: '{datosConsulta[consulta.fechaConsulta].notasModificacion.indicacionesAdicionales.ultimaModificacion.valor}'
                    por {datosConsulta[consulta.fechaConsulta].notasModificacion.indicacionesAdicionales.ultimaModificacion.medico} el
                    {datosConsulta[consulta.fechaConsulta].notasModificacion.indicacionesAdicionales.ultimaModificacion.fecha}
                  </p>
                )}
              </div>
            ))
          )}
          <div className="modal-buttons">
            <button type="submit">Guardar Cambios</button>
            <button type="button" onClick={onClose}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalEditarConsulta;
